<template>
  <div class="client-sidebar-menu left-sidebar">
    <div class="menu-items">
      <div
        class="menu-item"
        v-for="(menuItem, ndx) in menuItems"
        :key="`mt-${ndx}`"
      >
        <div
          class="wrapper-img"
          v-if="isShow(menuItem.code)"
        >
          <div class="img">
            <img
              :src="menuItem.img"
              alt=""
            />
          </div>
        </div>
        <div class="button-hover">
          <button @click="
              $store.dispatch('clientMain/setManageElement', menuItem.element)
            ">
            <span class="button-wrapper-img">
              <span class="img"><img
                  :src="menuItem.img"
                  alt=""
                /></span>
            </span>
            <span class="txt">{{ menuItem.title }}</span>
          </button>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: "SideBarMenu",
  data() {
    return {
      menuItems: [
        {
          title: this.$t("client.sidebarmenu.uchastok"),
          img: "/images/client/sidebar/1_uchastok.svg",
          element: "plot",
          code: "uchastok",
        },
        {
          title: this.$t("client.sidebarmenu.stely"),
          img: "/images/client/sidebar/2_stela.svg",
          element: "stely",
          code: "stely",
        },
        {
          title: this.$t("client.sidebarmenu.tumby"),
          img: "/images/client/sidebar/3_tumba.svg",
          element: "tumby",
          code: "tumby",
        },
        {
          title: this.$t("client.sidebarmenu.cvetniki_nadgrobiya"),
          img: "/images/client/sidebar/4_cvetnik.svg",
          element: "cvetniki-nadgrobiya",
          code: "cvetniki-nadgrobiya",
        },
        {
          title: this.$t("client.sidebarmenu.landscaping"),
          img: "/images/client/sidebar/5_blagoustroystvo.svg",
          element: "landscaping",
          code: "landscaping",
        },
        {
          title: this.$t("client.sidebarmenu.barriers"),
          img: "/images/client/sidebar/6_ogrady.svg",
          element: "barrier",
          code: "barriers",
        },
        {
          title: this.$t("client.sidebarmenu.vazy"),
          img: "/images/client/sidebar/7_vazy.svg",
          element: "vazy",
          code: "vazy",
        },
        {
          title: this.$t("client.sidebarmenu.stoliki"),
          img: "/images/client/sidebar/8_stoliki.svg",
          element: "stoliki",
          code: "stoliki",
        },
        {
          title: this.$t("client.sidebarmenu.skameiki"),
          img: "/images/client/sidebar/9_skameyki.svg",
          element: "skameiki",
          code: "skameiki",
        },
      ],
    };
  },
  methods: {
    isShow(code) {
      if (code === "uchastok") return true;
      if (code === "landscaping") return this.settings.use_landscaping;
      return (
        this.settings &&
        this.settings.elements_catalog &&
        this.settings.elements_catalog.some((el) => el.code === code)
      );
    },
  },
  computed: {
    settings() {
      return this.$store.state.settings.settings;
    },
  },
};
</script>

<style scoped>
.client-sidebar-menu {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.menu-pages {
  background-color: #223644;
  padding: 15px;
}
</style>
